import React from 'react';
import Reflux from 'reflux';
import GongqiFormItem from './GongqiFormItem';
import FormItemConst from './FormItemConst';
import {FocusSetStore} from '../stores/FocusStore';
import FocusActions from '../actions/FocusActions';
import {CmdUpdateControlAllowEditStore,DsAllowEditStore} from '../stores/CmdTypeStore';
import {CmdButtonOk,SetButtonStyleStore,CmdUpdateControlLabelStore} from '../stores/CmdTypeStore';
import {ButtonShortCutStore} from '../stores/CommandStore';
import FormItemUtil from '../utils/FormItemUtil';
import FormLookupFixed from '../components/FormLookupFixed';


require('../styles/FormItemButton.css');
/*{this.props.xml.name}*/

class FormItemButton extends GongqiFormItem
{
	constructor(props) {
		super(props);
		if(!this.props.forLookup)
		{
			this.unsubscribeCmdUpdateControlAllowEditStore = CmdUpdateControlAllowEditStore.listen(this.onCmdUpdateControlAllowEditStore.bind(this));
			this.unsubscribeCmdDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEdit.bind(this));
			this.unsubscribeCmdButtonOk = CmdButtonOk.listen(this.onButtonOk.bind(this));
			this.unsubscribeButtonShortCutStore = ButtonShortCutStore.listen(this.onShortCut.bind(this));
		}
		this.unsubscribeFocusSetStore = FocusSetStore.listen(this.onFocusSet.bind(this));
		this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
		this.unsubscribeSetButtonStyleStore = SetButtonStyleStore.listen(this.onSetButtonStyle.bind(this));
		let buttonStyles = this.getButtonStyles();
		if(buttonStyles)
			this.state.devStyles = Object.assign({},buttonStyles);
		else
			this.state.devStyles = {};
		this.state.label = this.props.label;
	}

	componentWillUnmount()
	{
		if(!this.props.forLookup)
		{
			this.unsubscribeCmdUpdateControlAllowEditStore();
			this.unsubscribeCmdDsAllowEditStore();
			this.unsubscribeCmdButtonOk();
			this.unsubscribeButtonShortCutStore();
		}
		this.unsubscribeFocusSetStore();
		this.unsubscribeCmdUpdateControlLabelStore();
		this.unsubscribeSetButtonStyleStore();
	}


	//命令调用buttonOK 作为shortCut处理
	onButtonOk(arg)
	{
		if(arg && arg.hasOwnProperty(this.props.xml.name))
		{
			this.testIframeToParentAction({target:this.btn},true);
		}
	}

	getButtonStyles()
	{
		let menuItemId = this.props.menuItemId;
		let formId = this.props.formId;
		let innerId = this.props.xml.id;
		return FormItemUtil.getControlStyles(menuItemId,formId,innerId);
	}

	onSetButtonStyle(formId,name)
	{
		if(this.props.xml.name == name && this.props.formId == formId)
		{
			let buttonStyles = this.getButtonStyles();
			if(buttonStyles)
			{
				if(Array.isArray(buttonStyles))
				{
					let tempObject = {};
					for(let i = 0;i<buttonStyles.length;i++)
					{
						Object.assign(tempObject,buttonStyles[i]);
						this.setState({devStyles:tempObject});
					}
				}
				else
				{
					this.setState({devStyles:buttonStyles});
				}
			}
				
		}
	}

	onCmdUpdateControlAllowEditStore(name,_allowEdit)
	{
		if(name == this.props.xml.name)
		{
			var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
			if(finalAllowEdit)$(this.btn).removeClass("disabled");
			else $(this.btn).addClass("disabled");

		}
	}

	onCmdUpdateControlLabel(name,_label,moduleInstanceId)
	{
		if(name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.setState({label:_label});
		}
	}

	onDsAllowEdit(groupAlias)
	{
		if(groupAlias == this.props.groupAlias)
		{
			var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
			if(finalAllowEdit)$(this.btn).removeClass("disabled");
			else $(this.btn).addClass("disabled");
		}
	}

	onShortCut(keyCodeStr)
	{
		let shortCut = this.props.control.getProperty_ShortCut();
		if(shortCut == keyCodeStr)
		{
			this.testIframeToParentAction({target:this.btn},true);
		}
	}

	componentDidMount()
	{
		var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
		if(_allowEdit)
		{
			if(this.props.initButtonOkCmd)
			{
				this.testIframeToParentAction({target:this.btn},true);
			}
			$(this.btn).removeClass("disabled");
		}
		else $(this.btn).addClass("disabled");
	}

	onFocusSet(formId,itemId,pre,init)
	{
		//alert(itemId + "  " + this.props.xml.id);
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			$(this.btn).focus();
			//$(this.inputField).select();
		}
	}

	onPrint(_value)
	{
		alert(_value);
	}

	restoreClikingFlag()
	{
		if(this.clickingId)
			clearTimeout(this.clickingId);
		this.isclicking = false;
		//console.log("恢复标记位：--》"+this.props.xml.name);
		
	}

	testAjax(num,url)
	{ 
		return $.ajax({
					type:'post',
					url:urlBase+"/GongqiERP/web"+url,
					data:num,
					async:true,
				
					/*success:function(data)
					{

						//console.log(num+"  远程调用返回");
					},
					error:function(data)
					{
						console.log(num);
					}*/
				
				});
	}

	async testSync(cmds) 
	{
		for(let i = 0;i<cmds.length;i++)//
		{
			let cmd = cmds[i];
			if(cmd == "2")
			{
				//执行远程调用
				console.log("执行本地操作  "+cmd+"  并引发远程调用");
				let cmd2 = await this.testAjax(cmd,"/test/test"+cmd);
				this.testSync([cmd2]);
			}
			else
			{
				console.log("执行本地操作  "+cmd);
			}
		}
	}
	
	//当时此button在下拉框上 属于第三极IFrame vv
	async testIframeToParentAction(event,shortCut=false)
	{
		/*var data1 ={id:1,name:"admin",pass:"gongqi"};
		var data2 ={id:2,mail:"ddd",phone:"23243"};
		window.parent.window.addIndexedDBData(data1);
		window.parent.window.addIndexedDBData(data2);
		return;*/
		//window.open("http://www.baidu.com");
		//1->setData 2->SelectNode 3->executeQuery 4->selectRow locateRow
		/*this.testSync(["1","2","4"]);
		return;*/
		/*var func_ = async function(cmds){

			for(let i = 0;i<cmds.length;i++)//
			{
				let cmd = cmds[i];
				if(cmd == 1)
				{
				//仅执行本地操作  xxx()
				}
				else
				{
				//执行远程调用
				let {cmd2} = await checkLogin();
				func_(cmd2);
				}
			}
		}*/
		
		if($(this.btn).hasClass("disabled"))
		{
			if(window.remainTasks)
			{
				let tasks = window.remainTasks;
				window.remainTasks = null;
				let task = tasks.shift();
		    	if(task)
		       		CommandResolver.doResolveTask(task,this.props.control.module,tasks);					
			}
			return;
		}
		if(this.isclicking == true)
		{
			return;
		}
		this.isclicking = true;
		await this.props.control.beforeOK(event,shortCut);
		let that = this;
		setTimeout(function(){
			that.isclicking = false;
		},250);
		
		return;
		
		/*if(!window.delayButtonClick)
		{
			this.props.control.beforeOK(event,shortCut);
		}
		else
		{
			
			
			if(this.isclicking == true)
			{
				//console.log("标记位阻止click：--》"+this.props.xml.name);
				return;
			}
			this.isclicking = true;
			this.clickingId = setTimeout(this.restoreClikingFlag.bind(this),1000);
			this.props.control.beforeOK(event,shortCut);*/
	
		
			
			
		/*	
			function(e){
						alert("恢复isclicking");
						clearTimeout(_id);
						_that.isclicking = false;

		},1000);*/
		return;
		// document.addEventListener("paste",function(e){alert("paste")});
		// document.execCommand("paste");
		// return;
		// var _parentWindow = window.parent.window;
		// if(_parentWindow)
		// {
		// 	if(typeof(_parentWindow.lookupReturnTest)=='function')
		// 		_parentWindow.lookupReturnTest();
		// }
	}

	onKeyDownHandler(e)
	{
		if(9===e.keyCode)
		{
			//alert(e.shiftKey)
			e.preventDefault();
			FocusActions.focusChange(this.props.xml,e.shiftKey);
		}
	}

	inputFieldFocus()
	{
		window.lastFocusUI = this.btn;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
	}

	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		if(!_style)_style = {};
		_style['margin'] = '2px';
		if(this.state.visible == false)
		{
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";
		}
		Object.assign(_style,this.state.devStyles,this.props.displayStyle,this.props.cssStyle);
		let label = this.state.label;

		let labels = label.split(/\\n/g);
		let list = [];
		for(let i = 0;i<labels.length;i++)
		{
			if(i==labels.length-1)
				list.push(labels[i]);
			else
				list.push(labels[i],<br/>);
		}
		let helpText = this.props.helpText;
		if(!helpText)helpText = "";

		//TODO 修改GOT DisplayStyle 上按钮的排列， 可能存在问题 
		var buttonAlinStyle = "";
		var buttonVerticalAlignment = "";
		var HorizontalAlignment = "";
		if(_style.VerticalAlignment){
			if(_style.VerticalAlignment =="Top"){
				buttonVerticalAlignment = "flex-start";
			}else if(_style.VerticalAlignment =="Center"){
				buttonVerticalAlignment = "center";
			}else if(_style.VerticalAlignment =="Bottom"){
				buttonVerticalAlignment = "flex-end";
			}
		}
		if(_style.HorizontalAlignment){
			if(_style.HorizontalAlignment =="Left"){
				HorizontalAlignment = "flex-start";
			}else if(_style.HorizontalAlignment =="Center"){
				HorizontalAlignment = "center";
			}else if(_style.HorizontalAlignment =="Right"){
				HorizontalAlignment = "flex-end";
			}
		}
		if(buttonVerticalAlignment || HorizontalAlignment){
			buttonAlinStyle = {"width":"100%","height":"100%","display":"flex","justify-content":buttonVerticalAlignment,"align-items":HorizontalAlignment,"flex-direction":"column","overflow":"auto"};
		}
		if(this.props.iconClass)
		{
			
			if(_style.display != "none"){_style.display = "flex";_style.alignItems = "center";}
			if(buttonAlinStyle){
				return <div style={buttonAlinStyle}><button title={helpText} id={this.props.xml.name} ref={node => this.btn = node} className='btn btn-info GongqiFormItemButton' onKeyDown={this.onKeyDownHandler.bind(this)}
				onClick={this.testIframeToParentAction.bind(this)} style={_style} onFocus={this.inputFieldFocus.bind(this)}><i className={this.props.iconClass}></i><div className="buttonIconOccupied">{list}</div></button></div>;
			}else{
				return <button title={helpText} id={this.props.xml.name} ref={node => this.btn = node} className='btn btn-info GongqiFormItemButton' onKeyDown={this.onKeyDownHandler.bind(this)}
				onClick={this.testIframeToParentAction.bind(this)} style={_style} onFocus={this.inputFieldFocus.bind(this)}><i className={this.props.iconClass}></i><div className="buttonIconOccupied">{list}</div></button>;
			}
	
		}
		else
		{
			if(buttonAlinStyle){
				return <div style={buttonAlinStyle}><button title={helpText} id={this.props.xml.name} ref={node => this.btn = node} className='btn btn-info GongqiFormItemButton' onKeyDown={this.onKeyDownHandler.bind(this)}
					onClick={this.testIframeToParentAction.bind(this)} style={_style} onFocus={this.inputFieldFocus.bind(this)}>{list}</button></div>;
			}else{
				return <button title={helpText} id={this.props.xml.name} ref={node => this.btn = node} className='btn btn-info GongqiFormItemButton' onKeyDown={this.onKeyDownHandler.bind(this)}
					onClick={this.testIframeToParentAction.bind(this)} style={_style} onFocus={this.inputFieldFocus.bind(this)}>{list}</button>;
			}
		}
	}
	
};

FormItemButton.defaultProps = {
};

export default FormItemButton;


// WEBPACK FOOTER //
// ./src/formItem/FormItemButton.js